import { User } from './../../../../models/user.model';
import { ISponsorship, Sponsorship } from './../../../../models/Sponsorship.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ParrainageService } from '../../../../services/parrainage.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import * as XLSX from "xlsx";
import { Location } from '@angular/common';
import { CommerciauxService } from '../../../../services/commerciaux.service';

@Component({
  selector: 'app-commercial-clients',
  templateUrl: './commercial-clients.component.html',
  styleUrls: ['./commercial-clients.component.scss']
})
export class CommercialClientsComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  commercialclients:any = [];
  commercialclientsTmp:any = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  perPage = 20;

  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  sorted7 = false;
  sorted8 = false;
  constructor(private activatedRoute: ActivatedRoute,
              private parrainageService : ParrainageService,
              private datePipe: DatePipe,private location: Location,
              private commerciauxService : CommerciauxService) { }

  ngOnInit(): void {
    this.loadUser();
  }

  disableEndDate = true;
  displayError = false;
  beginDate: any = null;
  endDate: any = null;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    // console.log(this.beginDate)
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }

  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }

  // filterClients() {
  //   if (this.endDate == null || this.beginDate== null) {
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
  //       showConfirmButton: false,
  //       timer: 3500
  //     });
  //     return;
  //   }
  //   if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
  //     const dateString = this.endDate;
  //     const date = new Date(dateString);
  //     date.setDate(date.getDate() + 1);
  //     this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
  //     this.commercialclients = this.commercialclientsTmp;
  //     this.commercialclients = this.commercialclients.filter((sp) => {
  //       let dateRef = this.datePipe.transform(sp.createdAt, 'yyyy-MM-dd');
  //       return (this.beginDate == null || dateRef >= this.beginDate) && (this.endDate == null || dateRef <= this.endDate);
  //     });
  //   }
  // }

  filterClients() {
    if (this.endDate == null || this.beginDate == null) {
        Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }

    const beginDateObj = new Date(this.beginDate);
    const endDateObj = new Date(this.endDate);

    endDateObj.setHours(23, 59, 59); // Définir l'heure sur 23:59:59 pour inclure toute la date de fin

    if (beginDateObj <= endDateObj) {
      this.commercialclients = this.commercialclientsTmp.filter((sp) => {
        const createdAtDate = new Date(sp.createdAt);
        return (createdAtDate >= beginDateObj) && (createdAtDate <= endDateObj);
      });
    }
  }

  calculateDaysBetweenDates(beginDate: string, endDate: string): number {
    const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

    const beginTimestamp = new Date(beginDate).getTime();
    const endTimestamp = new Date(endDate).getTime();

    if (isNaN(beginTimestamp) || isNaN(endTimestamp)) {
      throw new Error('Invalid date format. Please provide dates in the format: "yyyy-MM-dd".');
    }

    const differenceInMilliseconds = endTimestamp - beginTimestamp;
    const daysDifference = Math.round(differenceInMilliseconds / ONE_DAY_IN_MILLISECONDS);

    return daysDifference;
  }

  searchFilter($event: KeyboardEvent) {
    // console.log(this.search);
    this.search = this.search.toString().toLowerCase();
    this.commercialclients = this.commercialclientsTmp;
    this.commercialclients = this.commercialclients.filter(value =>
      value.firstname?.toUpperCase().includes(this.search)  || value.firstname?.toLowerCase().includes(this.search)
      || value?.lastname?.toUpperCase().includes(this.search) || value?.lastname?.toLowerCase().includes(this.search)
      || value?.email?.toUpperCase().includes(this.search) || value?.email?.toLowerCase().includes(this.search)
      || value?.phoneNumber?.toUpperCase().includes(this.search) || value?.phoneNumber?.toLowerCase().includes(this.search)
      || value?.createdAt.toString()?.toUpperCase().includes(this.search) || value?.createdAt.toString()?.toLowerCase().includes(this.search)
      || value?.gender?.toUpperCase().includes(this.search) || value?.gender.toLowerCase().includes(this.search)
    );
  }

  resetFilter() {
    this.loadUser();
    this.beginDate = null;
    this.endDate = null;
  }

  loadUser() {
    this.activatedRoute.params.subscribe(param => {
      this.onViewCommercialClients(param.id);
      this.clientAvecTransaction(param.id);
      this.clientSansTransaction(param.id);
      this.vendeurAvecAnnonce(param.id);
      this.vendeursansAnnonce(param.id);
    });
  }

  currentSponsorShip: any = null;
  isgetedd = true;
  comfirstName:any = "";
  comlastName:any = "";
  onViewCommercialClients(idS: any) {
    this.commerciauxService.getCommerClients(idS).subscribe(parrain =>  {
      // console.log("utilisateurs enrolés.....");
      // console.log(parrain);
      this.commercialclients = parrain;
      this.commercialclientsTmp = parrain;

        this.commercialclients.forEach(element => {
          if(this.isgetedd) {
            this.commerciauxService.getCommById(element.detailHowDidYouKnow).subscribe(rs=>{
              this.comfirstName = rs.firstname;
              this.comlastName =  rs.lastname;
              this.isgetedd = false;
            });
          }
        });

    });
  }

  NumberOfCustomerWithTransaction:any = 0;
  clientAvecTransaction(idC: any) {
    this.commerciauxService.getCommerClientTransaction(idC).subscribe((rs: any) =>  {
      this.NumberOfCustomerWithTransaction = rs.length;

    });
    //return this.NumberOfCustomerWithTransaction;
  }

  NumberOfCustomerWithoutTransaction:any;
  clientSansTransaction(idC: any) {
    this.commerciauxService.getCommerClientSansTransaction(idC).subscribe((rs: any) =>  {
      this.NumberOfCustomerWithoutTransaction = rs.length
    });
    //return this.NumberOfCustomerWithTransaction;
  }

  NumberOfSellerWithPost:any = 0;
  vendeurAvecAnnonce(idC: any) {
    this.commerciauxService.getCommerVendeurAvecAnnonce(idC).subscribe((rs:any) =>  {
      this.NumberOfSellerWithPost = rs.length

    });
    //return this.NumberOfSellerWithPost;
  }

  NumberOfSellerWithoutPost:any = 0;
  vendeursansAnnonce(idC: any) {
    this.commerciauxService.getCommerVendeurSansAnnonce(idC).subscribe((rs: any) =>  {
      //console.log(rs.length)
      this.NumberOfSellerWithoutPost = rs.length;
    });
    //return this.NumberOfSellerWithoutPost;
  }

  selectDisplayedClients(value: any){
    this.perPage = parseInt(value, 10);
  }

  goBack(): void {
    this.location.back();
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.lastname > b.lastname ? 1 : a.lastname < b.lastname ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.lastname < b.lastname ? 1 : a.lastname > b.lastname ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.firstname.toLowercase  > b.firstname.toLowercase ? 1 : a.firstname < b.firstname ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.firstname.toLowercase  < b.firstname.toLowercase  ? 1 : a.firstname > b.firstname ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
      this.sorted4 = false;
    }
  }

  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.gender > b.gender ? 1 : a.gender < b.gender ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.gender < b.gender ? 1 : a.gender > b.gender ? -1 : 0)
      this.sorted5 = false;
    }
  }

  sort6() {
    if(this.sorted6 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.phoneNumber > b.phoneNumber ? 1 : a.phoneNumber < b.phoneNumber ? -1 : 0)
      this.sorted6 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.phoneNumber < b.phoneNumber ? 1 : a.phoneNumber > b.phoneNumber ? -1 : 0)
      this.sorted6 = false;
    }
  }

  sort7() {
    if(this.sorted7 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.sellerAuthorization > b.sellerAuthorization ? 1 : a.sellerAuthorization < b.sellerAuthorization ? -1 : 0)
      this.sorted7 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.sellerAuthorization < b.sellerAuthorization ? 1 : a.sellerAuthorization > b.sellerAuthorization ? -1 : 0)
      this.sorted7 = false;
    }
  }

  sort8() {
    if(this.sorted8 == false) {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.activated > b.activated ? 1 : a.activated < b.activated ? -1 : 0)
      this.sorted8 = true;
    } else {
      // @ts-ignore
      this.commercialclients.sort((a, b) => a.activated < b.activated ? 1 : a.activated > b.activated ? -1 : 0)
      this.sorted8 = false;
    }
  }
}
